import React from "react";
import { Icon, IconBaseProps } from "./Icon";

const CloudRefreshIcon: React.FC<IconBaseProps> = props => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="M21.33 11.87a6.75 6.75 0 101.196 9.591.75.75 0 00-1.172-.936A5.25 5.25 0 1121.995 15H19.5a.75.75 0 000 1.5h3.75a.75.75 0 00.75-.75v-4.5a.75.75 0 00-1.5 0v1.755a6.746 6.746 0 00-1.17-1.135z" />
    <path d="M5.7.4a8.25 8.25 0 0110.397 5.335 5.62 5.62 0 017.02 2.112.75.75 0 11-1.265.806 4.118 4.118 0 00-5.814-1.171.75.75 0 01-1.164-.479A6.75 6.75 0 108.249 15a.75.75 0 11.002 1.5A8.25 8.25 0 015.701.4z" />
  </Icon>
);

export default CloudRefreshIcon;
